export enum SyncReconciliationStatus {
    NOT_STARTED = "NOT_STARTED",
    SYNC_IN_PROGRESS = "SYNC_IN_PROGRESS",
    SYNC_COMPLETED = "SYNC_COMPLETED"
}